<template>
  <div id="dqwz">
    <div class="headerbox">
      <!-- <em @click="gotoconact">联系我们</em>  -->
      <div class="leftbox">
         <div class="logo" @click="gotoindexbiaoqian"><img :src="logo" /></div>
         <dl class="navdl">
             <dt :class="dqon == index ? 'active' : ''" v-for="(item,index) in mcdatalist" v-if="item.state==1" :key="index" @click="gotopnav(index)">{{ item.name }}</dt>
            
         </dl>           
      </div>
    </div>
  </div>
</template>

<script>
import { getmainclass } from "@/api/api";
export default {
  data() {
    return {
      logo: require("@/assets/images/logo1.jpg"),
      searchvalue:'',
      mcdatalist:[],
      dqon:0
    };
  },
  created(){
     this.$Loading.finish();
     this.gogetmainclass();

     //判断当前页面
     if(this.$route.name=='index'){
       this.dqon = 0;
     }else if(this.$route.name=='ai'){
       this.dqon = 1;
     }else if(this.$route.name=='design'){
       this.dqon = 2;
     }else if(this.$route.name=='selfmedia'){
       this.dqon = 3;
     }else if(this.$route.name=='programmer'){
       this.dqon = 4;
     }else if(this.$route.name=='student'){
       this.dqon = 5;
     }else if(this.$route.name=='operation'){
       this.dqon = 6;
     }else if(this.$route.name=='officework'){
       this.dqon = 7;
     }else if(this.$route.name=='business'){
       this.dqon = 8;
     }else if(this.$route.name=='contact'){
       this.dqon = 50;
     }
  },
  mounted(){
    console.log('mcdata',this.mcdata);
  },
  methods:{
    gogetmainclass(){
      var that = this;
      var page=1,
        pageSize=20

      getmainclass(page,pageSize).then(res=>{
        console.log('res',res)
        that.mcdatalist = res.data.rows;
      })
    },
    //顶部导航选择
    gotopnav(index){
      this.dqon = index;
      console.log('this.dqon----------',this.dqon);
      //console.log('index',index);
      //console.log('this.mcdata',this.mcdata);
      if(this.mcdatalist[index].id==2){
        this.$router.push({
          name:'index'
        })
      }else if(this.mcdatalist[index].id==3){
        this.$router.push({
          name:'ai'
        })
      }else if(this.mcdatalist[index].id==5){
        this.$router.push({
          name:'design'
        })
      }else if(this.mcdatalist[index].id==4){
        this.$router.push({
          name:'selfmedia'
        })
      }else if(this.mcdatalist[index].id==8){
        this.$router.push({
          name:'programmer'
        })
      }else if(this.mcdatalist[index].id==13){
        this.$router.push({
          name:'student'
        })
      }else if(this.mcdatalist[index].id==15){
        this.$router.push({
          name:'operation'
        })
      }else if(this.mcdatalist[index].id==16){
        this.$router.push({
          name:'officework'
        })
      }else if(this.mcdatalist[index].id==17){
        this.$router.push({
          name:'business'
        })
      }
    },
    gotoconact(){      
      this.dqon = 100;
      this.$router.push({
        name:'contact'
      })
    },
    gotoindexbiaoqian(){
      this.dqon = 0;
      this.$router.push({
        name:'index'
      })
    }
  }
};
</script>

<style  lang="scss" scoped>
.headerbox {
   min-width:1220px;
  height: 70px; box-shadow: 0 0 5px #ccc;width: 100%;z-index: 50;
  background: #fff;//background: #01a6ff; 
  em{float: right; font-style: normal; font-size:15px; cursor: pointer; color: #333; padding-right:55px; padding-top:20px;}

  .leftbox{
      .logo{ width: 235px;
           display: flex; float: left; cursor: pointer;
           align-items: flex-start;padding-top:12px; padding-left:43px; padding-right: 25px;
           img{ width:150px;}
      }
      .navdl{ float: left; padding-left: 20px;
        dt{float: left; font-size:16px; color: #333; text-align: center; line-height: 60px; height: 60px; cursor: pointer; margin-left: 38px;}
        dt.active{border-bottom: 3px solid #27c42f;}
        dd{ float: left; margin-top: 12px; position: relative; margin-left: 30px;
          input{
            width: 230px; height: 37px; border: 1px solid #ddd; border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;transition:0.5s;
          }
          .addinput{
            width: 300px; height: 37px; border: 1px solid #ddd;  border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;
          }
          span{ position: absolute; right: 15px; top:0px; font-size:22px; color: #666; cursor: pointer;}
         
        }
      }
  }
 
}


</style>

<style>
.ivu-loading-bar-inner-color-primary{ background-color: #ffa200;}
</style>


// WEBPACK FOOTER //
// src/components/publish/headernav.vue